<div class="tribe-common-l-container tribe-events-l-container">
  <h1 class="heading_title__1bzno" style="margin-top: 30px">BD Market</h1>
</div>
<div class="wil-dashboard wil-content container" id="wilcity-dashboard">
  <section id="wilcity-dashboard-inner" class="wil-section wil-dashboard-inner pd-0">
    <div class="dashboard-content_module__zpEtP clearfix">
      <div class="dashboard__sidebar js-sticky filters-container">
        <app-shop-sidebar></app-shop-sidebar>
      </div>

      <div class="dashboard__content shop-dashboard-content">
        <div class="product-search-wrapper">
          <div class="product-search">
            <mat-form-field appearance="outline">
              <input matInput placeholder="Search Products" [(ngModel)]="params.keyword">
              <!-- <mat-icon matPrefix>search</mat-icon> -->
            </mat-form-field>

            <!-- <button mat-stroked-button color="primary" (click)="onSearchProduct()">Search</button> -->
            <button (click)="onSearchProduct()" class="wil-btn wil-btn--primary wil-btn--round wil-btn--md"
              type="button">
              <i class="la la-search"></i> Search
            </button>
          </div>

          <mat-form-field style="width: unset" appearance="legacy">
            <mat-select (selectionChange)="onSortChange($event.value)" [value]="sortOptions[0].value">
              <mat-option *ngFor="let opt of sortOptions" [value]="opt.value"> {{ opt.label }} </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="products-container" style="min-height: 600px" *ngIf="!(loading$ | async)">
          <div class="product-preview" *ngFor="let product of products; trackBy: trackByIdentity">
            <app-product-preview [product]="product"></app-product-preview>
          </div>
        </div>

        <div *ngIf="loading$ | async">
          <mat-spinner></mat-spinner>
        </div>

        <pagination [totalItems]="totalItems" [currentPage]="currentPage" [pageSize]="pageSize"
          (pageChange)="onPageChange($event)">
        </pagination>
      </div>
    </div>
  </section>
</div>